import { Flex } from 'foundations-components/components/Flex';
import { CardSection } from 'foundations-components/transitional/components/Card';
import { HR } from 'foundations-components/transitional/components/HR';
import { useCallback, useContext, useState } from 'react';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { EnablementTrackingContext } from '../../monitoring/EnablementTrackingContext';
import { Metrics } from '../../monitoring/Metrics';
import SRVEditorsBar from '../reportEditors/SRVEditorsBar';
import { SRVTablesInner } from '../singleReportViewer/common/SRVTables';
import AIReportSummaryWithReportPresets from '../singleReportViewer/common/report-summary/AIReportSummaryWithReportPresets';
import { showDatawellInsight } from '../singleReportViewer/fullPage/srv-datawell-insight/SRVDatawellInsight';
import ReportKPIContent from '../singleReportViewer/fullPage/srv-datawell-insight/sections/kpi/ReportKPIContent';
import { ADD_ONS } from './constants/ReportCardOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ReportCardBody({
  report,
  addOns,
  setPreviewReport,
  appUsageTracker,
  onReportResolve,
  onError,
  resetReportEdits,
  errorRenderer,
  enableReportResolveUsageTracking,
  noDataRenderer,
  ToolbarOverride,
  isReportRemixChange,
  vizContainerStyleProps
}) {
  const [localResolve, setLocalReportResolve] = useState(null);
  const {
    trackingApplicationName,
    trackingAssetType,
    trackingScreenName
  } = useContext(EnablementTrackingContext);
  const handleOnReportResolve = useCallback(args => {
    if (onReportResolve) {
      Metrics.counter('report-resolve-success').increment();
      onReportResolve(args);
    }
    setLocalReportResolve(args);
  }, [onReportResolve]);
  const handleOnReportError = useCallback(error => {
    if (onError) {
      Metrics.counter('report-resolve-error').increment();
      onError(error);
    }
  }, [onError]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [addOns.includes(ADD_ONS.DISABLE_CARD_WRAPPER) && ToolbarOverride, addOns.includes(ADD_ONS.SUMMARY_DATAWELL) && showDatawellInsight(report) && /*#__PURE__*/_jsxs(CardSection, {
      "data-test-id": "report-card-internal-summary",
      paddingInline: "0",
      children: [/*#__PURE__*/_jsx(ReportKPIContent, {
        appUsageTracker: appUsageTracker,
        previewReport: report,
        reportResolve: localResolve
      }), /*#__PURE__*/_jsx(HR, {})]
    }), addOns.includes(ADD_ONS.AI_INSIGHTS) && localResolve && /*#__PURE__*/_jsx(CardSection, {
      margin: "0",
      padding: "0",
      "data-test-id": "report-card-v2--ai-insights",
      children: /*#__PURE__*/_jsx(AIReportSummaryWithReportPresets, {
        appUsageTracker: appUsageTracker,
        report: report,
        reportResolve: localResolve,
        showAIBuilder: false,
        onChange: setPreviewReport,
        isReportRemixChange: isReportRemixChange,
        hideReportRemix: !addOns.includes(ADD_ONS.AI_REPORT_REMIX)
      })
    }), addOns.includes(ADD_ONS.EDITORS_BAR) && /*#__PURE__*/_jsx(CardSection, {
      margin: "0",
      padding: "0",
      "data-test-id": "report-card-v2--editors-bar",
      children: /*#__PURE__*/_jsx(SRVEditorsBar, {
        appUsageTracker: appUsageTracker,
        report: report,
        onPreviewReportChange: setPreviewReport,
        resetReportEdits: resetReportEdits
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      overflow: "auto",
      flexBasis: "auto",
      flexGrow: 1,
      flexShrink: 1,
      "data-test-id": "report-card-v2--resolver",
      children: /*#__PURE__*/_jsx(PlatformReportResolver, {
        compact: addOns.includes(ADD_ONS.COMPACT_CARD),
        useInlineLabels: !addOns.includes(ADD_ONS.DISABLE_INLINE_LABELS),
        report: report,
        onReportResolve: handleOnReportResolve,
        onLazyLoadingDeferredReportResolve: handleOnReportResolve,
        onError: handleOnReportError,
        errorRenderer: errorRenderer,
        wrapperComponent: "ReportCardV2",
        trackingApplicationName: trackingApplicationName,
        trackingAssetType: trackingAssetType,
        trackingScreenName: trackingScreenName,
        enableReportResolveUsageTracking: enableReportResolveUsageTracking,
        allowDrilldown: !addOns.includes(ADD_ONS.DISABLE_DRILLDOWN),
        lazyReportResolve: !addOns.includes(ADD_ONS.DISABLE_LAZY_REPORT_RESOLVE),
        noDataRenderer: noDataRenderer,
        onReportChange: setPreviewReport,
        hideExportButton: addOns.includes(ADD_ONS.DISABLE_EXPORT),
        vizContainerStyleProps: vizContainerStyleProps
      })
    }), addOns.includes(ADD_ONS.DATA_TABLES) && /*#__PURE__*/_jsx(CardSection, {
      marginBlockStart: "600",
      padding: "0",
      children: /*#__PURE__*/_jsx(SRVTablesInner, {
        previewReport: report,
        onPreviewReportChange: setPreviewReport,
        reportErrorRenderer: errorRenderer,
        reportIsEmpty: !(localResolve !== null && localResolve !== void 0 && localResolve.hasData)
      })
    })]
  });
}